var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-875 -399.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_560",
    "data-name": "\\u30D1\\u30B9 560",
    d: "M900.23,425.278,905.954,431,909,427.955l-5.723-5.724-.892.892-.615-.614a7.158,7.158,0,1,0-1.261,1.262l.614.615Zm-4.092-1.785a5.354,5.354,0,1,1,5.354-5.354A5.36,5.36,0,0,1,896.138,423.493Zm10.338,4.462-.523.522-3.2-3.2.523-.523Z",
    transform: "translate(-14 -11.793)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchInput);
export default __webpack_public_path__ + "static/media/icon_search_input.7047ef56e6bef7ac7adcf2ec270619be.svg";
export { ForwardRef as ReactComponent };